//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { crl8 } from 'app/curalate.globals';
import { pendoTracker } from 'app/initialization/pendo/pendo-tracker';

crl8.userSessionPromise.then((session) => {
  if (session) {
    pendoTracker.init(CURALATE_ENV.RELEASE, location.hostname, session);
  }
});
